
<div>
  <div class="item-info">
    <span
      class="single-text-omitted item-name"
      :title="
        slotProps?.selectedFile.fileType +
        '\r\n' +
        slotProps?.selectedFile.size +
        '\r\n' +
        slotProps?.selectedFile.fullname()
      "
      v-html="slotProps?.selectedFile.fullname()"
      v-if="!slotProps?.rename.active"
    ></span>
    <input
      class="item-rename-input"
      type="text"
      v-if="slotProps?.rename.active"
      v-model="slotProps.rename.value"
      ref="renameInputRef"
      v-on:keydown="slotProps?.funs.renameKeydown($event)"
      v-on:blur="slotProps?.funs.renameDone()"
    />
  </div>

  <div
    class="item-loading"
    v-if="slotProps?.loadingShow"
    :style="lodingStyle"
    :title="slotProps.loadingInfo"
  ></div>
</div>
